import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchObjectService } from '../../shared/services/search-object.service';
import { SERVICE_URL, SERVICE_API_VERSION } from '../../tokens';

@Injectable({
  providedIn: 'root',
})
export class MedicationService {

    constructor(private http: HttpClient, private searchObjectService: SearchObjectService, @Inject(SERVICE_API_VERSION) private apiVersion: string, @Inject(SERVICE_URL) private serviceUrl: any) {
    }

    searchDrugDetailsServices(): Observable<any> {
        const headers = new HttpHeaders({ 'cache-response': 'true' });
        return this.http.get(`${this.serviceUrl}DrugDetails`, { headers, params: this.getSearchParamsObject() });
    }

    getSearchParamsObject(): HttpParams {
        const searchObject = this.searchObjectService.getSearchObject();
        let formularyId = searchObject.formularyId && searchObject.formularyId.split('displayKey_').length > 1 ? searchObject.formularyId.split('displayKey_')[1] : searchObject.formularyId;  
        const fromObject = {
            'api-version' : '1',
            'formularyId' : formularyId,
            'drugId' : searchObject.drugId,
            'benefitYear' : searchObject.benefitYear
        };

        const params = new HttpParams({
            fromObject: this.removeEmpty(fromObject)
        });

        return params;
    }

    // TODO: make into pipe?
    removeEmpty = (obj) => {
        Object.keys(obj).forEach(key => {
            if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            delete obj[key];
            }
          });
        return obj;
    }
}
